export const scrollTo = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
  }
};

export const hidePrices = (): boolean => {
  const query = new URLSearchParams(location.search);
  return query.has('_hide_prices') && query.get('_hide_prices') === '1';
};
